import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    markViewedUrl: String,
  }

  connect() {
    this.hasMarkedViewed = false
  }

  markViewed(event) {
    if (this.hasMarkedViewed || !this.hasMarkViewedUrlValue) return

    event.preventDefault()
    this.hasMarkedViewed = true

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const targetUrl = event.currentTarget.getAttribute(
      'data-notification-target-url',
    )

    fetch(this.markViewedUrlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        Accept: 'application/json',
      },
      body: JSON.stringify({ read: true }),
      credentials: 'same-origin',
    })
      .then(() => {
        if (targetUrl) window.location.href = targetUrl
        return null
      })
      .catch(() => {})
  }
}
